import { createFileRoute } from "@tanstack/react-router"
import { CustomerCreator } from "modules/customers/components/List/Upsert/CustomerCreator"

export const Route = createFileRoute("/_base/_auth/customers/list/create")({
  component: CustomerCreator,
})
